import * as analytics from "./util/segment";

export default class Accordion {
    mount({ accordionSelector }) {
        const $anchors = $(`${accordionSelector} .anchor-link`);
        const { hash } = window.location;

        $anchors.each((idx, el) => {
            const $accordion = $(el).closest(".accordion");
            const $checkbox = $accordion.find(".accordion-checkbox");
            const $label = $accordion.find(".accordion-label");

            if ($(el).attr("href") === hash) {
                $checkbox.prop("checked", true).trigger("change");
            }

            $(el).click(() => {
                $checkbox.prop("checked", true).trigger("change");
            });

            $checkbox.change((event) => {
                let action;
                if (event.currentTarget.checked) {
                    action = "open-accordion";
                } else {
                    action = "close-accordion";
                }

                analytics.track({
                    action,
                    category: "accordion",
                    label: $label.text().trim(),
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/accordion.js